import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/api/api.service';
import { API_HOST } from '../../../../core/api/api.config';
import { ENDPOINTS } from '../../../../core/api/endpoints';
import { BehaviorSubject, Observable } from 'rxjs';

export interface OnboardingSubmitPayload {
  entySeq: number;
  entyType: number;
  cmmnt: string;
}

@Injectable({
  providedIn: 'root',
})
export class OnboradingService {
  // ================= CONTEXT STATE =================
  private _crptOnbrdngSeq$ = new BehaviorSubject<number | null>(null);
  private _clntSeq$ = new BehaviorSubject<number | null>(null);

  crptOnbrdngSeq$ = this._crptOnbrdngSeq$.asObservable();
  clntSeq$ = this._clntSeq$.asObservable();

  setCorporateSeq(seq: number | null) {
    this._crptOnbrdngSeq$.next(seq);
  }

  setClientSeq(seq: number | null) {
    this._clntSeq$.next(seq);
  }

  get crptOnbrdngSeq(): number | null {
    return this._crptOnbrdngSeq$.value;
  }

  get clntSeq(): number | null {
    return this._clntSeq$.value;
  }

  resetContext() {
    this._crptOnbrdngSeq$.next(null);
    this._clntSeq$.next(null);
  }

  // ================= API CALLS =================
  constructor(private api: ApiService) {}

  getClntAprvlLeads() {
    return this.api.get(API_HOST.leads, ENDPOINTS.LEADS.GET_ONBORAD_APRVD_LIST);
  }

  saveCorprate(payload: any): Observable<any> {
    return this.api.post(API_HOST.onboarding, ENDPOINTS.ONBOARDING.SAVE_CORPT_INFO, payload);
  }

  getCorporateById(id: number): Observable<any> {
    return this.api.get(API_HOST.onboarding, `${ENDPOINTS.ONBOARDING.GET_CORPT_INFO}/${id}`);
  }

  getRiskFatca(crprtOnbrdngSeq: number): Observable<any> {
    return this.api.get(
      API_HOST.onboarding,
      `${ENDPOINTS.ONBOARDING.GET_RISK_FACTA}/${crprtOnbrdngSeq}/3`,
    );
  }

  saveRiskFacta(payload: any): Observable<any> {
    return this.api.post(API_HOST.onboarding, ENDPOINTS.ONBOARDING.SAVE_RISK_FACTA, payload);
  }

  saveCorporatePerson(payload: any): Observable<any> {
    return this.api.post(API_HOST.onboarding, ENDPOINTS.ONBOARDING.SAVE_CORPORATE_PERSON, payload);
  }

  getCorporatePersons(crptOnbrdngSeq: number, prsnType: number): Observable<any> {
    return this.api.get(
      API_HOST.onboarding,
      `${ENDPOINTS.ONBOARDING.GET_CORPORATE_PERSONS}?crptOnbrdngSeq=${crptOnbrdngSeq}&prsnType=${prsnType}`,
    );
  }

  getCorporatePersonById(prsnSeq: number): Observable<any> {
    return this.api.get(
      API_HOST.onboarding,
      `${ENDPOINTS.ONBOARDING.GET_CORPORATE_PERSON}/${prsnSeq}`,
    );
  }

  deleteCorporatePerson(prsnSeq: number): Observable<any> {
    return this.getCorporatePersonById(prsnSeq);
  }

  saveCommitteeMembers(payload: {
    cmtSeq: number | null;
    cmtNm: string;
    crptOnbrdngSeq: number;
    prsnSeqs: number[];
    delFlg?: number;
  }): Observable<any> {
    return this.api.post(
      API_HOST.onboarding,
      ENDPOINTS.ONBOARDING.SAVE_CMT_MMBRS,
      payload,
    );
  }

  getAllCommittees(crptOnbrdngSeq: number): Observable<any> {
    return this.api.get(
      API_HOST.onboarding,
      `${ENDPOINTS.ONBOARDING.GET_ALL_CMT}/${crptOnbrdngSeq}`,
    );
  }

  getAllCorporatePersons(crptOnbrdngSeq: number): Observable<any> {
    return this.api.get(
      API_HOST.onboarding,
      `${ENDPOINTS.ONBOARDING.GET_ALL_CORPORATE_PERSONS}/${crptOnbrdngSeq}`,
    );
  }
  // onboarding.service.ts

  saveOnboardingReview(payload: {
    entySeq: number;
    entyType: number;
    cmmnt: string;
    clntSeq: number | null;
  }): Observable<any> {
    return this.api.post(API_HOST.onboarding, ENDPOINTS.ONBOARDING.SAVE_ONBORDING, payload);
  }

  /**
   * Submit onboarding ab entySeq, entyType aur cmmnt ek hi body mein bhejta
   * hai — saveOnboardingReview ki alag call ki zaroorat nahi.
   */
  SubmitOnboarding(payload: OnboardingSubmitPayload): Observable<any> {
    return this.api.post(API_HOST.onboarding, ENDPOINTS.ONBOARDING.SUBMIT_ONBOARDING, payload);
  }

  rejectOnboarding(leadSeq: number): Observable<any> {
    return this.api.post(
      API_HOST.onboarding,
      `${ENDPOINTS.ONBOARDING.RJCT_ONBRNG_CLNT}?leadSeq=${leadSeq}`,
      {},
    );
  }

  getOnboardingReview(onbrdngSeq: number): Observable<any> {
    return this.api.get(
      API_HOST.onboarding,
      `${ENDPOINTS.ONBOARDING.GET_ONBOARDING_REVIEW}/${onbrdngSeq}/3`,
    );
  }

  getAllNotifications(): Observable<any> {
    return this.api.get(API_HOST.notification, ENDPOINTS.NOTIFICATION.GET_ALL_NOTIFICATIONS);
  }

  getUnreadNotifications(): Observable<any> {
    return this.api.get(API_HOST.notification, ENDPOINTS.NOTIFICATION.GET_UNREAD_NOTIFICATIONS);
  }

  markNotificationRead(payload: {
    ntfctnSeq: number;
    rdFlg: boolean;
    dltFlg: boolean;
  }): Observable<any> {
    return this.api.post(
      API_HOST.notification,
      ENDPOINTS.NOTIFICATION.MARK_NOTIFICATION_READ,
      payload,
      {
        responseType: 'text',
      },
    );
  }

  GetOBAprvdList(): Observable<any> {
    return this.api.get(API_HOST.cradit, ENDPOINTS.CRADIT.GET_OB_APRVD_LIST);
  }

  sendBackOnboardingToRO(onbrdingSeq: number): Observable<any> {
    return this.api.post(
      API_HOST.onboarding,
      `${ENDPOINTS.ONBOARDING.SEND_BACK_ONBRNG_CLNT}/${onbrdingSeq}`,
      {},
    );
  }
  getCorporateInformationByEntitySeq(
  entySeq: number,
): Observable<any> {
  return this.api.get(
    API_HOST.onboarding,
    `${ENDPOINTS.ONBOARDING.GET_CORPT_INFO_BY_ENTITY}/${entySeq}`,
  );
}

  // ================= CNIC EXPIRY =================
  getCnicExpList(): Observable<any[]> {
    return this.api.get(API_HOST.client, ENDPOINTS.CLIENT.GET_CNIC_EXP_LIST);
  }

  getInProcsCnicList(): Observable<any[]> {
    return this.api.get(API_HOST.client, ENDPOINTS.CLIENT.GET_INPROCS_CNIC_LIST);
  }

  updateCnicExp(payload: FormData): Observable<any> {
    return this.api.post(API_HOST.client, ENDPOINTS.CLIENT.UPDATE_CNIC_EXP, payload);
  }

  approveCnicExp(cnicNum: string | number): Observable<any> {
    return this.api.post(API_HOST.client, `${ENDPOINTS.CLIENT.APRV_CNIC_EXP}${cnicNum}`, {});
  }
}